// extracted by mini-css-extract-plugin
export default {"cls1":"TypeWriter-cls1__5Z","cls2":"TypeWriter-cls2_LtZ TypeWriter-cls1__5Z"};